import { confirmAction } from "@/lib/dialogs";

const inr = (v) => `₹${Number(v).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

/**
 * Runs `send(allowBelowCost)`. If the server says some lines sell below cost, shows them and only sends anyway when the
 * person confirms; otherwise rejects with { cancelled: true } so the caller stays on the form.
 */
export async function sendWithCostCheck(send) {
  try {
    return await send(false);
  } catch (err) {
    const d = err?.response?.data?.detail;
    if (err?.response?.status !== 409 || d?.code !== "BELOW_COST") throw err;
    const list = d.lines.slice(0, 8).map((l) => `#${l.number} ${l.description}: sell ${inr(l.rate)} vs cost ${inr(l.cost_rate)} (short by ${inr(l.short_by)})`).join("\n");
    const more = d.lines.length > 8 ? `\n…and ${d.lines.length - 8} more` : "";
    const ok = await confirmAction({
      kind: "warning", title: "Some lines sell below cost", confirmLabel: "Send anyway", cancelLabel: "Go back and fix",
      message: `${d.message}\n\n${list}${more}`,
    });
    if (!ok) throw Object.assign(new Error("cancelled"), { cancelled: true });
    return send(true);
  }
}
